import { render, staticRenderFns } from "./NotDriverMonthlyScoreView.vue?vue&type=template&id=42b91484&"
import script from "./NotDriverMonthlyScoreView.vue?vue&type=script&lang=js&"
export * from "./NotDriverMonthlyScoreView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports